import { useCallback, useEffect, useState } from "react";
import { getListFileImport } from "../../services/uploadFile";

const useListFileImport = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getListFileImport();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useListFileImport;
